<template>
  <div>
    <header>
      <div class="container">
        <!-- Logo -->
        <a class="grey pb-logo pull-left-lg d-flex justify-content-center" :href="getLocalPath()" title="No-IP - Managed DNS Service Provider">
          <img src="https://d2np5nlsc31ci5.cloudfront.net/assets/img/logo/logo-grey.png" alt="No-IP Logo" srcset="https://d2np5nlsc31ci5.cloudfront.net/assets/img/logo/logo-grey_@2x.png 2x" />
        </a>
        <div v-if="auth.loggedIn" class="user-login pull-right-sm">
          <i class="icon-user-1"></i>
          {{ $t('account.logged_in_as') }}:
          <a class="blue" href="/redirect/mynoip" onclick="ga('send', 'event', 'top-nav', 'click', 'mininav-username');">{{ auth.username ? auth.username : auth.email }}</a>
        </div>
        <div class="col-md-8 col-xs-12 pl-0 pr-0 mx-auto pull-none-lg">
          <div class="d-table w-100 w-100">
            <div class="breadcrumb active pulse">
              <div id="1" class="builder-breadcrumb"></div>
              <span class="title">{{ $t('topnav.planbuilder') }}</span>
              <div class="pb-step-bar-left"></div>
              <div class="pb-step-bar-right"></div>
            </div>
            <div class="breadcrumb">
              <div id="2" class="builder-breadcrumb"></div>
              <span class="title">{{ $t('topnav.payment') }}</span>
              <div class="pb-step-bar-left"></div>
              <div class="pb-step-bar-right"></div>
            </div>
            <div class="breadcrumb">
              <div id="3" class="builder-breadcrumb"></div>
              <span class="title">{{ $t('topnav.orderconfirmation') }}</span>
              <div class="pb-step-bar-left"></div>
              <div class="pb-step-bar-right"></div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ENGLISH } from '../../plan-builder/store/modules/locale';

export default {
  name: 'TopNav',

  computed: {
    ...mapState({
      auth: state => state.auth,
      lang: state => state.locale.lang
    })
  },

  methods: {
    getLocalPath: function () {
      const noEnglishLocalePath = this.lang === ENGLISH ? '' : this.lang;
      return '/' + noEnglishLocalePath;
    },

    ...mapActions('auth', ['setAuth']),
    ...mapActions('locale', ['setLocale'])
  },

  created() {
    let account_json = document.body.querySelector('input[name="_user"]').value;
    let account_data = JSON.parse(account_json);
    this.setAuth(account_data);
    let locale = document.body.querySelector('input[name="_locale"]').value;
    if (locale) this.setLocale(locale);
  }
};
</script>
